import { useQuery } from '@tanstack/react-query';
import type { CandidateSearchStatus } from '../types/SuggestedCandidate';
import type {
  AgentApiCandidateProfilesIndex,
  AgentApiCandidateProfilesItem,
} from '@/types/serializers';

interface SearchCandidatesParams {
  keyword?: string;
  status?: CandidateSearchStatus | '';
  boardId?: number;
  excludeJobPostId?: number;
}

interface SearchCandidatesResponse {
  candidates: AgentApiCandidateProfilesItem[];
  total_count: number;
}

export default function useSearchCandidates(params: SearchCandidatesParams) {
  const { keyword = '', status = '', boardId, excludeJobPostId } = params;

  return useQuery({
    queryKey: ['searchCandidates', keyword, status, boardId, excludeJobPostId],
    queryFn: async () => {
      // TODO: 仮実装 - 将来的に専用の検索APIに置き換え
      // 現在は候補者一覧APIを使用して、フロントエンドでフィルタリング
      const searchQuery: Record<string, string | number[]> = {};
      if (keyword) searchQuery.keyword = keyword;
      if (status) searchQuery.status = status;
      if (boardId) searchQuery.candidate_board_ids = [boardId];

      const queryParams = new URLSearchParams();
      queryParams.append('per_page', '50');
      Object.entries(searchQuery).forEach(([key, value]) => {
        if (key === 'candidate_board_ids' && Array.isArray(value)) {
          value.forEach((id) => {
            queryParams.append(`search_query[${key}][]`, id.toString());
          });
        } else {
          queryParams.append(`search_query[${key}]`, value as string);
        }
      });

      const response = await fetch(`/agent/api/candidate_profiles.json?${queryParams}`);

      if (!response.ok) {
        throw new Error('Failed to search candidates');
      }

      const data: AgentApiCandidateProfilesIndex = await response.json();

      // APIレスポンスをそのまま返す
      return {
        candidates: data.records,
        total_count: data.total_count,
      } as SearchCandidatesResponse;
    },
    enabled: true,
  });
}
